'use client';

import { tokenRepository } from 'Shared/network';
import type { ChildrenProps } from '@viewup/ui';
import { createContext, useContext, useEffect, useState } from 'react';

type TokenStoreProps = {
  accessToken: string;
  actions: {
    setToken: (token: string) => void;
  };
};

const TokenStoreContext = createContext<TokenStoreProps | null>(null);

export const AuthProvider = (props: ChildrenProps & { token?: string }) => {
  const { children, token = '' } = props;
  const [accessToken, setAccessToken] = useState<string>(token);

  useEffect(() => {
    const getToken = () => {
      tokenRepository.getToken().then((accessToken) => {
        if (accessToken) {
          setAccessToken(accessToken);
          return;
        }

        setAccessToken('');
        tokenRepository.removeToken();
      });
    };

    if (token) {
      setAccessToken(token);
      tokenRepository.saveToken(token);
      return;
    }

    getToken();
  }, [props.token]);

  return (
    <TokenStoreContext.Provider value={{ accessToken, actions: { setToken: setAccessToken } }}>
      {children}
    </TokenStoreContext.Provider>
  );
};

export const useTokenStore = () => {
  const tokenStore = useContext(TokenStoreContext);
  if (!tokenStore) {
    throw new Error('TokenStoreContext is not defined');
  }
  return tokenStore;
};
